import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { getUmami } from '@lib/umami';

@Injectable({
    providedIn: 'root'
})
export class metricsGuard implements CanActivate, CanActivateChild {
	constructor() {}

    canActivate(): boolean {

        getUmami().subscribe(umami => umami.track());

        return true;
	}

	canActivateChild(): boolean { return this.canActivate(); }
}